import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IncomingInvoiceProfile, ReceiptProfile, User } from "models/propTypes/userProfilePropTypes";
import { PaymentListItem, GenericPaymentListProps } from "models/propTypes/paymentPropTypes";
import { Amount } from "models/utilTypes/currencyType";
import { BankIdPaymentType } from "models/enums/payment";
//#endregion
//#region components
import PaymentList from "../paymentListTable";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const GenericBankIdPaymentList: React.FC<GenericPaymentListProps> = (props) => {
  return (
    <PaymentList
      properties={{
        profileName: {
          description: TranslationKeys.Common.Counterpart,
          formatter: (values: PaymentListItem) => new User(values.profileId ?? 0, values.profileName),
          noWrap: true,
          maxWidth: 220,
        },
        paymentDate: {
          description: TranslationKeys.Common.Date,
          formatter: (values: PaymentListItem) => new Date(values.date),
          noWrap: true,
          maxWidth: 130,
        },
        dueDate: {
          formatter: (values: PaymentListItem) => values.dueDate && new Date(values.dueDate),
          description: TranslationKeys.Common.Due_Date,
          noWrap: true,
        },
        number: {
          formatter: (values: PaymentListItem) =>
            values.type === BankIdPaymentType.IncomingInvoice
              ? new IncomingInvoiceProfile(values.id, values.number ?? "")
              : values.type === BankIdPaymentType.Receipt
              ? new ReceiptProfile(values.id, values.number ?? "")
              : values.number,
          description: TranslationKeys.Common.Number,
          className: cssExports.textBlue,
          alignment: "right",
          noWrap: true,
        },
        amount: {
          formatter: (values: PaymentListItem) => values.amount && new Amount(values.amount.type, values.amount.value),
          description: TranslationKeys.Common.Amount,
          noWrap: true,
          className: cssExports.textBlack,
          alignment: "right",
        },
        group: {
          formatter: (values: PaymentListItem) => {
            return LocalizationHelperInstance.getFormattedMessage(
              values.type === BankIdPaymentType.IncomingInvoice
                ? TranslationKeys.IncomingInvoice.IncomingInvoices
                : values.type === BankIdPaymentType.Receipt
                ? TranslationKeys.Common.Receipts
                : ""
            );
          },
        },
      }}
      items={props.items ?? []}
      disableRowSelection={props.disableRowSelection}
      onRowSelectionsChange={props.onRowSelectionsChange}
      moreActions={props.moreActions}
    ></PaymentList>
  );
};

export default GenericBankIdPaymentList;
